import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import Swal from 'sweetalert2';
import moment from 'moment';
import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import { filterErrorHandler } from "../../hoc/Shared/utility";

import DelayBonusListing from './DelayBonusListing';
import DelayBonusEdit from './DelayBonusEdit';
import TransactionDetails from '../Transaction/TransactionDetails';
import MemberShow from '../Members/MemberShow/MemberShow';
import * as actionCountry from "../../store/ducks/country/actions";

import * as actions from '../../store/ducks/delayBonus/actions';

const initialInputState =
{
    order_id: '',
    username: '',
    status: '',
    min_amount: '',
    transaction_date: '',
    start_date: '',
    end_date: '',
    member_country: "",
};

class DelayBonus extends Component {
    constructor(props)
    {
        super(props);
        this.state = 
        {
            pageShow: 'listing',
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: '',
            totalRecords: 0,
            searchValue: '',
            filter: initialInputState,
            data: [],
            dropDown:
            {
                status: [],
            },
            countryDropDown: {
                member_country_option: [],
            },
            detailsParam: {},
            loading: true,
            redirectParam: {}
        }
        this.onInputChange = this.onInputChange.bind(this);
    }

    componentDidMount()
    {
        const listingArr = this.getFilterArray(); 
        this.props.funcGetList(listingArr); 
        this.props.funcGetDropDown(); 
        this.props.getCountryDropdown();
    }

    componentWillUnmount() {}

    shouldComponentUpdate(nextProps, nextState)
    {
        const { t } = this.props;

        if (nextProps.rs !== this.props.rs && nextProps.rs !== undefined) {
            if (nextProps.rs.responseCode === 200 && nextProps.rs.msgType === 'success') {
                this.setState({
                    data: nextProps.rs.data.result.row,
                    totalRecords: nextProps.rs.data.result.pagination.total_record,
                    loading: false,
                })
            }
            else {
                this.setState({
                    data: [],
                    totalRecords: 0,
                    activePage: 1,
                    loading: false,
                }, () => {
                    filterErrorHandler(nextProps.rs.message);
                })
            }
        }

        if (nextProps.dropDown !== this.props.dropDown && nextProps.dropDown !== undefined)
        {
            if(nextProps.dropDown.responseCode === 200 && nextProps.dropDown.msgType === 'success')
            {
                this.setState({
                    dropDown:
                    {
                        status: nextProps.dropDown.data.status,
                    }
                });
            }
            else 
            {
                this.setState({
                    dropDown:
                    {
                        status: [],
                        loading: false
                    }
                }, () => {
                    filterErrorHandler(nextProps.dropDown.message);
                });
            }
        }

        if (nextProps.countryDropDown !== this.props.countryDropDown && nextProps.countryDropDown !== undefined) {
            if (nextProps.countryDropDown && nextProps.countryDropDown.responseCode === 200 && nextProps.countryDropDown.msgType === "success") {
            
                this.setState({
                    countryDropDown: {
                        member_country_option: nextProps.countryDropDown.data.country_dropdown
                    },
                });
            }
            else 
            {
                this.setState({
                    countryDropDown:
                    {
                        member_country_option: [],
                        loading: false
                    }
                }, () => {
                    filterErrorHandler(nextProps.countryDropDown.message);
                });
            }
        }

        if (nextProps.updateStatus !== this.props.updateStatus && nextProps.updateStatus !== undefined) 
        {
            if(nextProps.updateStatus.responseCode === 200 && nextProps.updateStatus.msgType === 'success')
            {
                Swal.fire({
                    icon: 'success',
                    title: t('global.success'),
                    html: t('global.record-updated'),
                    showConfirmButton: true
                }).then(() =>
                {
                    this.refreshHandler();
                });
            }
            else
            {
                this.setState({
                    loading: false
                }, () => {
                    filterErrorHandler(nextProps.updateStatus.message);
                })
            }
        }

        return true;
    }

    onInputChange(event)
    {
        let newFilter = Object.assign({}, this.state.filter);
        newFilter[event.target.id] = event.target.value;
        if(event.target.id ==='transaction_date')
        {
            const date = (event.target.value!=='') ? event.target.value.split(' - ') : null;
            newFilter['start_date'] = (date) ? date[0] : '';
            newFilter['end_date'] = (date) ? date[1] : '';
        }
        this.setState({
            filter: newFilter
        });
    }

    clearHandler = () =>
    {
        let newFilter = initialInputState;
        this.setState({
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),            
            filter: newFilter,
            loading: true,
            data: [],
            order: ''
        }, ()=>
        {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }

    editHandler = (e, id, order_id) =>
    {
        e.preventDefault();
        this.setState({
            pageShow: 'edit',
            detailsParam :
            {
                id: id,
                order_id: order_id
            }
        });
    }

    detailsHandler = (e, id) =>
    {
        e.preventDefault();
        this.setState({
            pageShow: 'details',
            detailsParam :
            {
                id: id
            }
        });
    }

    delayBonusApproveHandler = (e, id, order_id) =>
    {
        const { t } = this.props;
        let htmlText = `<span>${t('validation.confirmation_check')}</span>`;
    
        e.preventDefault();
        Swal.fire({
            title: t('validation.confirmation'),
            html: htmlText,
            icon: 'warning',
            confirmButtonText: t('global.save'),
            showDenyButton: true,
            denyButtonText: t('global.cancel'),
        }).then((result) => 
        {
            if (result.isConfirmed) 
            {
                Swal.fire({
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                });
                let data = {};
                data.id = id;
                data.order_id = order_id;
                data.act = 'approve';
                data.lang_id = this.props.currentUser.language_id;
                this.props.funcUpdateTranStatus(data);
            }
        });
    }

    refreshHandler = () =>
    {
        this.setState({
            loading: true,
            data: [],
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            order: ''
        }, ()=>
        {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }

    getFilterArray = () =>
    {
        const listingArr = {};
        let availablePage = this.state.activePage;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.activePage >= availablePage) && this.setState({ activePage: availablePage});
        }

        listingArr.page = (this.state.activePage >= availablePage) ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        // listingArr.country_id = this.props.currentUser.country_id;
        Object.keys(this.state.filter).forEach((val) =>
        {
            listingArr[val] = ((val==='start_date' || val==='end_date') && this.state.filter[val]!=='') ? moment(this.state.filter[val]).format('YYYY-MM-DD HH:mm:ss') : this.state.filter[val];
        });
        return listingArr;
    }

    changePageHandler = (page) =>
    {
        this.setState({
            pageShow: page,
        });
    }

    datatablesChangeHandler = (val, act) =>
    {
        this.setState({
            [act]: (act==='searchValue') ? val.target.value : val,
            loading: true,
            data: [],
        }, () =>
        {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }

    onSort = (field, order) =>
    {
        const orderArry = [{}];
        let orderSequence = (order === 'asc') ? true : false ;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({
            order: orderArry,
            loading: true,
            data: [],
        }, () =>
        {
            const listingArr = this.getFilterArray();
            this.props.funcGetList(listingArr);
        });
    }

    redirectHandler = (e, id, name) => {
        const filteredRows = this.props.rs.data.result.row.filter(row => row.username === name);
        e.preventDefault();
        this.setState({
            pageShow: "redirect",
            redirectParam: {
                id: id,
                name: name,
                shortcode: filteredRows[0]['memberCountry'],
            }
        });
    }

    render() {
        return (
        <Auxiliary>
            {this.state.pageShow === 'listing' &&
                <DelayBonusListing
                    filter={this.state.filter}
                    changePageHandler={(page) => this.changePageHandler(page)}
                    clearHandler={() => this.clearHandler()}
                    refreshHandler={() => this.refreshHandler()}
                    editHandler={(event, id, order_id) => this.editHandler(event, id, order_id)}
                    detailsHandler={(event, id) => this.detailsHandler(event, id)}
                    delayBonusApproveHandler={(event, id, order_id) => this.delayBonusApproveHandler(event, id, order_id)}
                    onInputChange={(event) => this.onInputChange(event)}
                    datatablesChangeHandler={(val, act) => this.datatablesChangeHandler(val, act)}
                    onSort={(field, order) => this.onSort(field, order)}
                    redirectHandler={(event,id,name)=>this.redirectHandler(event,id,name)}
                    data={this.state.data}
                    activePage={this.state.activePage}
                    limit={this.state.limit}
                    totalRecords={this.state.totalRecords}
                    searchValue={this.state.searchValue}
                    loading={this.state.loading}
                    permission={this.props.currentUser.permission ?? []}

                    ddStatus={this.state.dropDown.status}
                    ddMemberCountry={this.state.countryDropDown.member_country_option}
                />
            }

            {this.state.pageShow==='details' &&
                <TransactionDetails
                    detailsParam={this.state.detailsParam}
                    changePageHandler={(page) => this.changePageHandler(page)}
                    returnPage='listing'
                    currentUser={this.props.currentUser}
                />
            }

            {this.state.pageShow==='edit' &&
                <DelayBonusEdit
                    detailsParam={this.state.detailsParam}
                    refreshHandler={() => this.refreshHandler()}
                    changePageHandler={(page) => this.changePageHandler(page)}

                    bankList={this.state.dropDown.bankList}
                    bankAccountList={this.state.dropDown.bankAccountList}
                />
            }

            {this.state.pageShow==='redirect' &&
                <MemberShow 
                    memberShowId={this.state.redirectParam.id}
                    memberShowUsername={this.state.redirectParam.name}
                    memberShowCountry= {this.state.redirectParam.shortcode}
                    changePageHandler={(page) => this.changePageHandler(page)}
                    permission={this.props.currentUser.permission ?? []}
                    memberShowCount={0}
                />
            }
        </Auxiliary>
        )
    }
}

const mapStateToProps = state =>
{
    return {
        rs: state.delayBonus.rs,
        dropDown: state.delayBonus.dropDown,
        updateStatus: state.delayBonus.updateStatus,
        currentUser: state.currentUser.data,
        countryDropDown: state.country.country_dropdown,

    }
};

const mapDispatchToProps = dispatch =>
{
    return {
        funcGetList: (filter) => dispatch(actions.getList(filter)),
        funcGetDropDown: () => dispatch(actions.getDropDown()),
        getCountryDropdown: () => dispatch(actionCountry.getCountryDropdown()),
        funcUpdateTranStatus: (data) => dispatch(actions.updateTranStatus(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps) (withNamespaces('translation')(DelayBonus));